// extracted by mini-css-extract-plugin
export default {"body_home":"HomePage_body_home__epu4H","body_left":"HomePage_body_left__RSFt7","body_right":"HomePage_body_right__LZPCE"};